// import React, { useState } from "react";
// import { FaRegFileCode } from "react-icons/fa";
// import { RiCustomerService2Line } from "react-icons/ri";
// import { FiMonitor } from "react-icons/fi";
// import { FaChalkboardTeacher } from "react-icons/fa";
// import Filter from "./Filter";
// import { Link } from "react-router-dom";
// import Skeleton from "../Skeleton/Skeleton";
// import Error from "../Error/Error";
// import ProjectCard from "./ProjectCard";
// import './Banner.css'
// const Projects = ({ projects, isLoading, isError, error, slice }) => {
//     // console.log(projects);
//     const [filterOption, setFilterOption] = useState();
//     const [searchOption, setSearchOption] = useState();
//     // console.log(typeof filterOption);

//     const filterHandler = (option) => {
//         if (option !== "") {
//             setFilterOption(option);
//         }
//         if (option === "") {
//             setFilterOption(false);
//         }
//     };
//     const searchHandler = (query) => {
//         if (query) {
//             // console.log(query)
//             setSearchOption(query);
//         }
//         if (query === "") {
//             setSearchOption(false);
//         }
//     };

//     let content;

//     if (isLoading) content = <Skeleton />;
//     if (isError) content = <Error error={error} />;
//     if (!isError && !isLoading && !filterOption) {
//         // console.log(projects);
//         const newProjects = [...projects];
//         const reversedProjects = newProjects.reverse();

//         content = (
//             <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mt-10">
//                 {reversedProjects?.slice(0, slice).map((project) => {
//                     // console.log(project);

//                     return <ProjectCard project={project} key={project._id} />;
//                 })}
//             </div>
//         );
//     }


//     //  filtered data render------------>

//     if (!isError && !isLoading && filterOption) {
//         const newProjects = [...projects];
//         const reversedProjects = newProjects.reverse();
//         const filteredData = reversedProjects.filter((data) => data.project_type === filterOption);

//         content = (
//             <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mt-10">
//                 {filteredData?.slice(0, slice).map((project) => {
//                     console.log(project);

//                     return <ProjectCard project={project} />;
//                 })}
//             </div>
//         );
//     }
//     //  filtered data render------------>

//     //  searched data render------------>
//     if (!isError && !isLoading && searchOption) {
//         console.log(searchOption);
//         // const newProjects = [...projects];
//         // const reversedProjects = newProjects.reverse();
//         const filteredData = projects.filter((data) => {
//             console.log(data.name.toLowerCase());
//             return data.name.toLowerCase().includes(searchOption.toLowerCase());
//         });
//         console.log(filteredData);
//         content = (
//             <div className="grid grid-cols-1 md:grid-cols-3 gap-4  mt-10">
//                 {filteredData?.slice(0, slice).map((project) => {
//                     console.log(project);

//                     return <ProjectCard project={project} />;
//                 })}
//             </div>
//         );
//     }
//     //  searched data render------------>

//     return (
//         <div className="md:mt-72  mt-20 w-full ">
//             <div data-aos="fade-up "
//                 data-aos-anchor-placement="center-bottom">
//                 {/* <h3 className="text- text-4xl text-highlight mt-">
//                     {"<"} Projects {"/>"}
//                 </h3> */}
//  <h3 className="text- flex justify-center text-4xl mb-6 text-highlight">
//                 <div className='flex gap-3 items-center  border-[2px] w-[189px] border-white py-1 px-5 hover:bg-white hover:text-black rounded-3xl'>Project <span className="hover:rotate-180 "> <img className="w-6 h-6" alt="imag" loading="lazy" src="https://i.ibb.co/G3xK0m8/im.png"/></span></div>

                    
//                 </h3>
                
//                 <h1 className="md:text-5xl text-4xl   font-bold md:w-2/3 w-full p-0  mx-auto text-white mt-8 text uppercase">
//                     What I Did for my client
//                 </h1>
//             </div>


//             <Filter filterHandler={filterHandler} searchHandler={searchHandler}  />

//             {content}
//         </div>
//     );
// };

// export default Projects;


import React, { useState } from "react";

import Filter from "./Filter";

import Skeleton from "../Skeleton/Skeleton";
import Error from "../Error/Error";
import ProjectCard from "./ProjectCard";
import './Banner.css';

const Projects = ({ projects, isLoading, isError, error, slice }) => {
    const [filterOption, setFilterOption] = useState();
    const [searchOption, setSearchOption] = useState();

    const filterHandler = (option) => {
        if (option !== "") {
            setFilterOption(option);
        }
        if (option === "") {
            setFilterOption(false);
        }
    };

    const searchHandler = (query) => {
        if (query) {
            setSearchOption(query);
        }
        if (query === "") {
            setSearchOption(false);
        }
    };

    let content;

    if (isLoading) content = <Skeleton />;
    if (isError) content = <Error error={error} />;
    if (!isError && !isLoading && !filterOption && !searchOption) {
        const newProjects = [...projects];
        const reversedProjects = newProjects.reverse();

        content = (
            <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mt-10 ">
                {reversedProjects?.slice(0, slice).map((project) => {
                    return <ProjectCard project={project} key={project._id} />;
                })}
            </div>
        );
    }

    // Filtered data render
    if (!isError && !isLoading && filterOption) {
        const newProjects = [...projects];
        const reversedProjects = newProjects.reverse();
        const filteredData = reversedProjects.filter((data) => data.project_type === filterOption);

        if (filteredData.length === 0) {
            content = (
                <div className="not-found-animation">
                    <h2>Not found</h2>
                </div>
            );
        } else {
            content = (
                <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mt-10">
                    {filteredData?.slice(0, slice).map((project) => {
                        return <ProjectCard project={project} />;
                    })}
                </div>
            );
        }
    }

    // Searched data render
    if (!isError && !isLoading && searchOption) {
        const filteredData = projects.filter((data) => {
            return data.name.toLowerCase().includes(searchOption.toLowerCase());
        });

        if (filteredData.length === 0) {
            content = (
                <div className="not-found-animation">
                    <h2>Result not found</h2>
                </div>
            );
        } else {
            content = (
                <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mt-10">
                    {filteredData?.slice(0, slice).map((project) => {
                        return <ProjectCard project={project} />;
                    })}
                </div>
            );
        }
    }

    return (
        <div className="md:mt-72 mt-20 w-full lg:px-10 ">
            <div data-aos="fade-up" data-aos-anchor-placement="center-bottom">
                <h3 className="text- flex justify-center text-4xl mb-6 text-highlight">
                    <div className='flex gap-3 items-center border-[2px] w-[189px] border-white py-1 px-5 hover:bg-white hover:text-black rounded-3xl'>
                        Project <span className="hover:rotate-180"> <img className="w-6 h-6" alt="imag" loading="lazy" src="https://i.ibb.co/G3xK0m8/im.png" /></span>
                    </div>
                </h3>
                <h1 className="md:text-5xl text-4xl font-bold md:w-2/3 w-full p-0 mx-auto text-white mt-8 text uppercase">
                    What I Did for my client
                </h1>
            </div>

            <Filter filterHandler={filterHandler} searchHandler={searchHandler} />

            {content}
        </div>
    );
};

export default Projects;
